

export const Finish = () => {

  return (
    <>
      <div class="tab-pane fade show active" id="pills-experience" role="tabpanel">
          <div class="text-center">
              <div class="avatar-md mt-5 mb-4 mx-auto">
                  <div class="avatar-title bg-light text-success display-4 rounded-circle">
                      <i class="ri-checkbox-circle-fill"></i>
                  </div>
              </div>
              <h5>Well Done !</h5>
              <h6 class="text-success">You have Successfully Send info</h6>
              <p class="text-muted">Please wait ........</p>
          </div>
      </div>
    </>
  )

}